import { IError } from "dto/IError";

export const getErrorMessage = (error?: IError) => {
  //@ts-ignore
  if (error && error.errorCodes) {
    //@ts-ignore
    const messages = error.errorCodes.map((x) => x.message);

    return messages.join(", ");
  }

  if (error && error.response?.data) {
    const messages = error.response.data.errorCodes.map((x) => x.message);

    return messages.join(", ");
  }

  return "";
};
